//translates error returned by redux-api-middleware into rejection understood by redux-form
import LocalizedStrings from '../localization/strings';
import moment from 'moment';

export function translateAPIResponse(result) {
    if (result.error && result.payload.name === 'ApiError' && result.payload.response && result.payload.response.errors) {
        return Promise.reject(result.payload.response.errors);
    }
    return result;
}

export function validateRequiredValueFields(values, fields, errors) {
  fields.forEach((field) => {
    const value = values[field];
    if (value === null || value === undefined || value === '') {
      errors[field] = LocalizedStrings.requiredField;
    }
  });
  return errors;
}

export function validateRequiredFields(values, fields, errors) {
    fields.forEach((field) => {
        if (!values[field]) {
            errors[field] = LocalizedStrings.requiredField;
        }
    });
    return errors;
}
export function validateEmail(values, field, errors) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(values[field])) {
        errors[field] = LocalizedStrings.invalidEmailField;
    }
    return errors;
}
export function validateDate(values, field, errors) {
    if (!moment(values[field]).isValid()) {
        errors[field] = LocalizedStrings.invalidDateField;
    }
    return errors;
}



// WEBPACK FOOTER //
// ./src/js/utils/form.js